import { Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useState } from 'react';
import LoadingBackdrop from 'src/components/ui-component/loading/LoadingBackdrop';
import MuiDialog from 'src/components/ui-component/mui-dialog/MuiDialog';
import MuiSnackbar from 'src/components/ui-component/mui-snackbar/MuiSnackbar';
import { useAuthentication } from 'src/context/AuthContext';
import { PostRecord } from 'src/lib/api/PostRecord';
import { APIS } from 'src/lib/constants/apis';
import { AUSLOESENDE_AKTION, NACHRICHT_ORDNER } from 'src/lib/constants/constant';
import { enumT, getFieldNamefromDataPath } from 'src/utils/helper';

// import schemas
import FoerderProgrammSchema from 'src/lib/paths/foerderprogramm_FULL_Paths.json';
import NachrichtSchema from 'src/lib/paths/nachricht_FULL_Paths.json';
const P = NachrichtSchema.attributes;
const FP_P = FoerderProgrammSchema.attributes;

const SkizzeUeberspringenPopUp: FC<{ foerderProgramm: any; onClose: () => void }> = ({ onClose, foerderProgramm }) => {
	const { authenticatedData } = useAuthentication();

	const foerderProgrammID = Number(get(foerderProgramm, 'id', null));
	const antragsformular = get(foerderProgramm, FP_P.Allgemein_Antragsformular.path, '');

	const [wsActive, setWsActive] = useState(false);
	const [wsError, setWsError] = useState(false);

	const [showPopUp, setShowPopUp] = useState('');

	const handleCreateNachricht = async () => {
		try {
			onClose();

			setWsActive(true);

			const nachrichtData = {
				[getFieldNamefromDataPath(P.Foerderprogramm.path)]: foerderProgrammID,
				[getFieldNamefromDataPath(P.Allgemein_Ordner.path)]: NACHRICHT_ORDNER.Postausgang,
				[getFieldNamefromDataPath(P.Antragsteller.path)]: get(authenticatedData, 'organisationId', null),
				[getFieldNamefromDataPath(P.Allgemein_Betreff.path)]: `Antrag auf Skizze-überspringen "${enumT(antragsformular)}"`,
				[getFieldNamefromDataPath(P.Allgemein_Inhalt.path)]: `Es liegt eine Antrag auf Skizze-überspringen für "${enumT(antragsformular)}"`,
				[getFieldNamefromDataPath(P.Allgemein_Freischaltung_Beantragt_Fuer.path)]: antragsformular,
				[getFieldNamefromDataPath(P.Allgemein_ausloesende_Aktion.path)]: AUSLOESENDE_AKTION.SkizzeLiegtExternVor,
				[getFieldNamefromDataPath(P.Allgemein_Erstellt.path)]: new Date(),
			};

			const res = await PostRecord(APIS['Portal-Nachricht'], { data: nachrichtData });
			if (res) {
				let pushNotificationdata = { data: { entities: [{ api: 'nachrichts', id: get(res, 'data.id') }] } };
				const pushRes = await PostRecord(APIS.PushNotificaiton, pushNotificationdata);
				if (pushRes) setShowPopUp(antragsformular);
			} else {
				setWsError(true);
			}
		} catch (err: any) {
			console.error('ERROR: name ', err);
			setWsError(true);
		} finally {
			setWsActive(false);
		}
	};

	return (
		<>
			<LoadingBackdrop open={wsActive} />
			<MuiSnackbar showSnackbar={wsError} error={wsError} closeSnackbar={() => setWsError(false)} alertMessage='Etwas is schief gelaufen' />

			<MuiDialog
				open={foerderProgrammID > 0}
				title={`Skizze für "${enumT(antragsformular)}" überspringen`}
				content={
					<Stack spacing={2}>
						<Typography>
							Haben Sie bereits die Skizze extern eingereicht und möchten diese nun überspringen, um direkt mit der Antragstellung
							fortzufahren?
						</Typography>
						<Typography>
							<strong>Ja?</strong> Kicken Sie jetzt direkt auf den Button “beantragen”.
						</Typography>
						<Typography>
							Sie werden automatisch benachrichtigt, sobald Ihre Skizze geprüft wurde und Sie einen Antrag erstellen können.
						</Typography>
					</Stack>
				}
				onClose={() => onClose()}
				onConfirmButtonName={'Beantragen'}
				onConfirm={handleCreateNachricht}
			/>

			<MuiDialog
				open={showPopUp !== ''}
				title={`Freischaltung Antragsformular "${enumT(showPopUp)}" beantragt`}
				content={
					<Stack spacing={2}>
						<Typography>
							Ihre Anfrage zur Freischaltung des Antragsformulars "{enumT(showPopUp)}" für Ihr Förderprojekt wurde erfolgreich versendet.
						</Typography>
						<Typography>Sie werden automatisch benachrichtigt, sobald Ihre Freischaltung erfolgt ist.</Typography>
					</Stack>
				}
				onClose={() => {
					setShowPopUp('');
				}}
				onCloseButtonName={'Schließen'}
			/>
		</>
	);
};

export default SkizzeUeberspringenPopUp;
